export class ListZeroEtlJobSyncsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<ZeroEtlJobSync>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlJobSyncsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
